<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div>
          <h1>Smart indexer api PL</h1>
          <p>
            Adres url API:
            <a href="https://smartindexer.net/api.php"
              >https://smartindexer.net/api.php</a
            >
          </p>
          <p>Parametry:</p>
          <p>apikey [string] - klucz API dostępny w panelu</p>
          <p>cmd [string] - dostępne są 2 polecenia:</p>
          <ul>
            <li>submit - przesłanie linków</li>
            <li>remaininglimit - pozostały limit linków</li>
          </ul>
          <p>campaign [string] - nazwa kampanii</p>
          <p>urls [string] - lista adresów url do przesłania</p>
          <p>
            Zwróć uwagę, że nie ma parametru dripfeed, parametr ten ustawiasz w
            panelu (<a href="https://app.smartindexer.net/#/settings"
              >https://app.smartindexer.net/#/settings</a
            >
            - API default dripfeed)- tam możesz ustawić jak chcesz rozkładać
            przesłane linki.
          </p>
          <p>przykładowa implementacja:</p>
          <p>
            curl -s -X POST -d "apikey=TWOJ-KLUCZ_API&cmd=remaininglimit" "<a
              href="https://smartindexer.net/api.php"
              >https://smartindexer.net/api.php</a
            >"
          </p>
        </div>
        <div>
          <h1>Smart indexer api EN</h1>
          <p>
            Adres url API:
            <a href="https://smartindexer.net/api.php"
              >https://smartindexer.net/api.php</a
            >
          </p>
          <p>Parameters:</p>
          <p>apikey [string] - API key available in the panel</p>
          <p>cmd [string] - two commands are available:</p>
          <ul>
            <li>submit - link submission</li>
            <li>remaininglimit - remaining links limit</li>
          </ul>
          <p>campaign [string] - campaign name</p>
          <p>urls [string] - list of url's to upload</p>
          <p>
            Note that there is no dripfeed parameter, you set this parameter in
            the panel (<a href="https://app.smartindexer.net/#/settings"
              >https://app.smartindexer.net/#/settings</a
            >
            - API default dripfeed)- there you can set how you want to dripfeed
            your links.
          </p>
          <p>example implementation:</p>
          <p>
            curl -s -X POST -d "apikey=TWOJ-KLUCZ_API&cmd=remaininglimit" "<a
              href="https://smartindexer.net/api.php"
              >https://smartindexer.net/api.php</a
            >"
          </p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Docs",
  data() {
    return {};
  },
};
</script>
